import React, { ComponentType } from 'react';

import classNames from 'classnames';

export enum BadgeVariant {
  DEFAULT = '',
  PINK = 'pink',
  PURPLE = 'purple',
  BLUE = 'blue',
  GREEN = 'green',
  RED = 'red',
  ORANGE = 'orange',
}

export enum BadgeSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}

type Props = {
  size?: BadgeSize;
  icon?: ComponentType<{ className?: string }>;
  text?: string;
  isReversed?: boolean;
  variant?: BadgeVariant;
  className?: string;
};

export const Badge = ({
  size = BadgeSize.SMALL,
  icon,
  text = '',
  variant = BadgeVariant.DEFAULT,
  isReversed = false,
  className = '',
}: Props) => {
  const Icon = icon;

  return (
    <span
      className={classNames(
        `badge badge-${size}`,
        variant === BadgeVariant.DEFAULT ? '' : `badge-${variant}${isReversed ? '-reverse' : ''}`,
        className,
      )}
    >
      {Icon && <Icon className="badge-icon" />}
      {text}
    </span>
  );
};
